import React from 'react';
import { Card, List, Avatar } from 'antd';
import { IPlan } from '../../types/plans';
import { ImageSlider } from './ImageSlider';

const { Meta } = Card;

const metaPlanList = {
  fontWeight: '230',
  fontSize: '16px',
  lineHeight: '27px',
  fontFamily: 'Open Sans, sans-serif',
  color: '#4a4a4a',
};

const preApprovedBadgeStyle = {
  position: 'absolute' as const,
  bottom: '8px',
  right: '8px',
  backgroundColor: '#7ec8ba',
  color: 'white',
  fontSize: '12px',
  fontWeight: 'bold',
  padding: '4px 8px',
  borderRadius: '8px',
  zIndex: 1,
};

export const Plan = ({
  item,
  onPlace = () => [],
}: {
  item: IPlan;
  onPlace: (e: React.MouseEvent<HTMLDivElement>, plan: IPlan) => void;
}) => {
  const { meta, isHidden, photos, preApproved } = item;

  return (
    <div style={{ position: 'relative' }}>
      <Card
        cover={
          <ImageSlider
            photos={photos || []}
            fallbackImage={item.logo || item.image}
            isHidden={isHidden}
            onClick={e => onPlace(e, item)}
          />
        }
        hoverable
        onClick={e => onPlace(e, item)}>
        <Meta
          avatar={
            <Avatar src="https://s3-us-west-2.amazonaws.com/adu.homewip/images/eb48c0f5-6673-4f56-9cbd-4b6d3e55e138" />
          }
          title={(item.title || 'House').toUpperCase()}
          description={
            <div>
              {meta.width ? <span style={metaPlanList}>Width: {meta.width}&apos;</span> : null}
              {meta.length ? <span style={metaPlanList}>Length: {meta.length}&apos;</span> : null}
            </div>
          }
        />
      </Card>
      {preApproved && <div style={preApprovedBadgeStyle}>Pre-Approved</div>}
    </div>
  );
};

export const Plans = ({
  items,
  onPlace,
  currentPage,
  onPageChange,
  totalCount,
}: {
  items: IPlan[];
  onPlace: (e: React.MouseEvent<HTMLDivElement>, plan: IPlan) => void;
  currentPage: number;
  onPageChange: (page: number) => void;
  totalCount: number;
}) => {
  const pageSize = 10;

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      dataSource={items}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: totalCount,
        showSizeChanger: false,
        position: 'both',
        style: {
          margin: '1em',
        },
        onChange: onPageChange,
      }}
      renderItem={item => {
        return (
          <List.Item>
            <Plan item={item} onPlace={onPlace} />
          </List.Item>
        );
      }}
    />
  );
};
